export default "__VITE_ASSET__DqZ6kF49__"